const Calls = () => {
  return <div>Calls</div>;
};
export default Calls;
